// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 62.625em){.search_bar-module__wrapper--3hjt_{max-width:734px}}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "search_bar-module__wrapper--3hjt_"
};
module.exports = exports;
